<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.goodstransfer') }}
            <template v-if="ready">
              >
              {{ goodstransfer.gt_code }}
            </template>
          </div>
        </div>
        <template v-if="device.isMobile">
          <div class="col-7 right pl-0">
            <div
              v-if="goodstransfer !== null"
              class="action">
              <div
                v-if="showOptionButton"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="openCloneModal()">
                    <i class="fas fa-copy"/>
                    <span class="name">{{ $t('button.clone') }}</span>
                  </a>
                  <a
                    class="dropdown-item"
                    @click="openPrintModal()">
                    <i class="fas fa-print"/>
                    <span class="name">{{ $t('button.print') }}</span>
                  </a>
                  <a
                    v-if="hasRoleDelete"
                    class="dropdown-item"
                    @click="openConfirmdeleteModal()">
                    <i class="fas fa-trash text-danger"/>
                    <span class="text-danger">{{ $t('button.delete') }}</span>
                  </a>
                </div>
              </div>
              <!-- status button -->
              <div
                v-if="goodstransfer.status == 'padding' && hasRoleEdit"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.gt.padding') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="openReceivedorderModal()">
                    <i
                      class="far fa-check-circle text-success"
                      style="position: relative; left: -7px;"/>
                    <span class="text-success">{{ $t('status.gt.done') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <template v-else>
                <div
                  v-if="goodstransfer.status == 'padding'"
                  class="dropdown item">
                  <span class="text-info">
                    {{ $t('status.gt.padding') }}
                  </span>
                </div>
                <div
                  v-if="goodstransfer.status == 'done'"
                  class="dropdown item">
                  <span class="text-success">
                    {{ $t('status.gt.done') }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-7 right">
            <div
              v-if="goodstransfer !== null"
              class="action">
              <div
                v-if="showOptionButton"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    v-if="hasRoleDelete"
                    class="dropdown-item"
                    @click="openConfirmdeleteModal()">
                    <i class="fas fa-trash text-danger"/>
                    <span class="text-danger">{{ $t('button.delete') }}</span>
                  </a>
                </div>
              </div>
              <div
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openCloneModal()">
                  <i class="fas fa-copy"/>
                  <span class="name">{{ $t('button.clone') }}</span>
                </button>
              </div>
              <!-- print button -->
              <div class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openPrintModal()">
                  <i class="fas fa-print"/>
                  <span class="name">{{ $t('button.print') }}</span>
                </button>
              </div>
              <!-- status button -->
              <div
                v-if="goodstransfer.status == 'padding' && hasRoleEdit"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.gt.padding') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="openReceivedorderModal()">
                    <i
                      class="far fa-check-circle text-success"
                      style="position: relative; left: -7px;"/>
                    <span class="text-success">{{ $t('status.gt.done') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <template v-else>
                <div
                  v-if="goodstransfer.status == 'padding'"
                  class="dropdown item">
                  <span class="text-info">
                    {{ $t('status.gt.padding') }}
                  </span>
                </div>
                <div
                  v-if="goodstransfer.status == 'done'"
                  class="dropdown item">
                  <span class="text-success">
                    {{ $t('status.gt.done') }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <WrapperDoc>
          <template #form>
            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.date')"
                  :subtitle="$t('series.gt')+' ' + goodstransfer.gt_code"/>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('apps.inventory.message.transferdate') }}</label>
                        <BaseInputDatePicker
                          v-model="form.selectedDate"
                          :disabled="disabledForm"
                          mode="dateTime"
                          is24hr
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="goodstransfer.posting_at"
                    class="col-md-6"
                  >
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('apps.inventory.message.postingattransferredorders') }}</label>
                        <input
                          :class="[{'text-danger': goodstransfer.posting_at == null}, {'text-success': goodstransfer.posting_at !== null}]"
                          :disabled="true"
                          :value="goodstransfer.posting_at ? getDateTime(goodstransfer.posting_at) : '-'"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('apps.inventory.message.transfer')"/>
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group form-row">
                      <div class="col-md-12">
                        <div class="form-row">
                          <div class="col-md-6">
                            <label>{{ $t('apps.inventory.message.transferfrom') }}</label>
                            <select
                              :class="validate.pickedWarehouseIdFrom"
                              :disabled="true"
                              v-model="form.pickedWarehouseIdFrom"
                              class="form-control custom-select"
                            >
                              <option :value="null">
                                {{ $t('placeholder.select') }}
                              </option>
                              <option
                                v-for="(item, index) in warehouses"
                                :key="index"
                                :value="item.warehouse_id"
                              >
                                {{ item.warehouse_name }}
                              </option>
                            </select>
                          </div>
                          <div
                            v-if="optionFromBinLocations.length > 1"
                            class="col-md-6">
                            <label>&nbsp;</label>
                            <BaseDropdown
                              v-model="form.pickedBinIdFrom"
                              :options="optionFromBinLocations"
                              :disabled="true"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-row">
                          <div class="col-md-6">
                            <label>{{ $t('apps.inventory.message.transferto') }}</label>
                            <select
                              :class="validate.pickedWarehouseIdTo"
                              :disabled="true"
                              v-model="form.pickedWarehouseIdTo"
                              class="form-control custom-select"
                            >
                              <option :value="null">
                                {{ $t('placeholder.select') }}
                              </option>
                              <option
                                v-for="(item, index) in warehouses"
                                :key="index"
                                :value="item.warehouse_id"
                              >
                                {{ item.warehouse_name }}
                              </option>
                            </select>
                          </div>
                          <div
                            v-if="optionToBinLocations.length > 1"
                            class="col-md-6">
                            <label>&nbsp;</label>
                            <BaseDropdown
                              v-model="form.pickedBinIdTo"
                              :options="optionToBinLocations"
                              :disabled="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.orderlist')"/>
                <OrderGT
                  :validation="form.trickValidation"
                  :data="form.orders"
                  :createAble="true"
                  :showProductImage="true"
                  :selectedWhIdFrom="form.pickedWarehouseIdFrom"
                  :selectedWhIdTo="form.pickedWarehouseIdTo"
                  :disabled="disabledForm"
                  @submit="onSubmitOrder"
                />
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('placeholder.note') }}</label>
                        <textarea
                          :placeholder="$t('placeholder.dotted')"
                          v-model="form.note"
                          :disabled="disabledForm"
                          class="form-control"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              v-if="!disabledForm"
              class="action-bar"
            >
              <div
                v-if="!$store.state.app.loading"
                class="col-md-12 text-right">
                <button
                  class="btn btn-web"
                  @click="form.trickValidation++;">{{ $t('button.save') }}</button>
              </div>
              <div
                v-if="$store.state.app.loading"
                class="col-md-12 text-right">
                <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
                <button
                  class="btn btn-web btn-block-mobile-only"
                  disabled><i class="fas fa-spinner spin"/></button>
              </div>
            </section>
          </template>
          <template #ref>
            <DocRef
              :refDoc="`gt`"
              :refId="goodstransfer.gt_id"
              :refCode="goodstransfer.gt_code"
              :showLog="getInventorySetting.log_topic.is_active"
              :showAttachFile="getInventorySetting.attach_file.is_active"
              :logTopics="getInventorySetting.log_topic.options"
              :isSubmitted="isSubmitted"
            />
          </template>
        </WrapperDoc>
      </template>
    </div>

    <div
      id="doneModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-1000"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('apps.inventory.message.transferorder_header') }}</h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="cancel()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="mb-3">
              <section-title :title="$t('message.productlist')+ ' ('+doneOrders.length+')'"/>
              <div
                v-for="(data, index) in doneOrders"
                :key="index"
                class="col-12 box mb-2">
                <div class="row">
                  <div class="col-12">
                    <div class="form-row">
                      <div class="col-12 col-lg-6 mb-mobile-2">
                        <BaseInput
                          :value="data.item"
                          :disabled="true"/>
                      </div>
                      <div class="col-6 col-lg-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('apps.inventory.message.initialdemand') }}</span>
                          </div>
                          <input
                            :value="data.quantity"
                            :disabled="true"
                            type="text"
                            class="form-control text-right number-only text-select-all"
                          >
                        </div>
                      </div>
                      <div class="col-6 col-lg-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('apps.inventory.message.receivedcount') }}</span>
                          </div>
                          <input
                            :disabled="isUseLot(data.sku_id) || isUseSerial(data.sku_id)"
                            v-model="doneOrders[index].done"
                            type="number"
                            class="form-control text-right number-only text-select-all textfield-done"
                            placeholder="0"
                            @change="checkReceivedNumber(doneOrders[index])"
                            @keyup="checkReceivedNumber(doneOrders[index])"
                          >
                        </div>
                      </div>
                    </div>
                    <template v-if="isUseLot(data.sku_id) && data.stockout.lot_numbers.length">
                      <div class="form-row mt-2">
                        <div
                          class="col-12"
                          style="margin-bottom: -10px;">
                          <section-title :title="`${$t('apps.inventory.label.lotnumber')}: ${$t('apps.inventory.label.pickfrom')}`" />
                        </div>
                        <div
                          v-for="(lot, lotIndex) in data.stockout.lot_numbers"
                          :key="lotIndex"
                          class="col-12 mt-2"
                        >
                          <div class="form-row">
                            <div class="col-3">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('series.lot') }}</span>
                                </div>
                                <input
                                  :value="lot.lot_code"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.label.bin') }}</span>
                                </div>
                                <input
                                  :value="getBinName(lot.bin_location_id)"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.message.deliveredcount') }}</span>
                                </div>
                                <input
                                  :value="lot.unit"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-row mt-2">
                        <div
                          class="col-12"
                          style="margin-bottom: -10px;">
                          <section-title :title="`${$t('apps.inventory.label.lotnumber')}: ${$t('apps.inventory.label.putawayto')}`" />
                        </div>
                        <div class="col-12 mt-2">
                          <div class="form-row">
                            <div class="col-9">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.label.bin') }}</span>
                                </div>
                                <input
                                  :value="getBinName(data.stockin.bin_location_id)"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="isUseSerial(data.sku_id) && data.stockout.serial_numbers.length">
                      <div class="form-row mt-2">
                        <div
                          class="col-12"
                          style="margin-bottom: -10px;">
                          <section-title :title="`${$t('apps.inventory.label.serialnumber')}: ${$t('apps.inventory.label.pickfrom')}`" />
                        </div>
                        <div
                          v-for="(serial, serIndex) in data.stockout.serial_numbers"
                          :key="serIndex"
                          class="col-12 mt-2"
                        >
                          <div class="form-row">
                            <div class="col-3">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('series.serial') }}</span>
                                </div>
                                <input
                                  :value="serial.ser_code"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.label.serialnumber') }}</span>
                                </div>
                                <input
                                  :value="serial.serial_number"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.label.bin') }}</span>
                                </div>
                                <input
                                  :value="getBinName(serial.bin_location_id)"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.message.deliveredcount') }}</span>
                                </div>
                                <input
                                  :value="1"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-row mt-2">
                        <div
                          class="col-12"
                          style="margin-bottom: -10px;">
                          <section-title :title="`${$t('apps.inventory.label.serialnumber')}: ${$t('apps.inventory.label.putawayto')}`" />
                        </div>
                        <div class="col-12 mt-2">
                          <div class="form-row">
                            <div class="col-9">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{ $t('apps.inventory.label.bin') }}</span>
                                </div>
                                <input
                                  :value="getBinName(data.stockin.bin_location_id)"
                                  :disabled="true"
                                  class="form-control text-right"
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="form-row mt-2">
                      <div class="col-12">
                        <section-title :title="$t('apps.inventory.message.newresult')" />
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-radius: 0.25em 0 0 0;">
                              {{ getWhLocationName(form.pickedWarehouseIdFrom, form.pickedBinIdFrom) }}
                            </span>
                          </div>
                          <input
                            :disabled="true"
                            :value="inStockTotal(
                              data.sku_id,
                              getStockId(form.pickedWarehouseIdFrom, data.sku_id),
                              form.pickedBinIdFrom
                            )"
                            type="text"
                            class="form-control text-right"
                            style="border-left: 0;border-radius: 0 0.25em 0 0;"
                          >
                        </div>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-top: 0px;border-radius: 0 0 0 0.25em;">
                              <i class="fas fa-sync-alt"/>
                            </span>
                          </div>
                          <input
                            :class="[
                              'form-control text-right',
                              inStockTotalAfterSubmit(
                                data.sku_id,
                                getStockId(form.pickedWarehouseIdFrom, data.sku_id),
                                form.pickedBinIdFrom,
                                doneOrders[index].done,
                                { isIncrement: false },
                              ) <= -1 ?
                                'text-danger' :
                                ''
                            ]"
                            :disabled="true"
                            :value="inStockTotalAfterSubmit(
                              data.sku_id,
                              getStockId(form.pickedWarehouseIdFrom, data.sku_id),
                              form.pickedBinIdFrom,
                              doneOrders[index].done,
                              { isIncrement: false },
                            )"
                            type="text"
                            style="border-left: 0px; border-top: 0; border-radius: 0 0 0.25em 0;"
                          >
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-radius: 0.25em 0 0 0;">
                              {{ getWhLocationName(form.pickedWarehouseIdTo, form.pickedBinIdTo) }}
                            </span>
                          </div>
                          <input
                            :disabled="true"
                            :value="inStockTotal(
                              data.sku_id,
                              getStockId(form.pickedWarehouseIdTo, data.sku_id),
                              form.pickedBinIdTo
                            )"
                            type="text"
                            class="form-control text-right"
                            style="border-left: 0;border-radius: 0 0.25em 0 0;"
                          >
                        </div>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-top: 0px;border-radius: 0 0 0 0.25em;">
                              <i class="fas fa-sync-alt"/>
                            </span>
                          </div>
                          <input
                            :class="[
                              'form-control text-right',
                              inStockTotalAfterSubmit(
                                data.sku_id,
                                getStockId(form.pickedWarehouseIdTo, data.sku_id),
                                form.pickedBinIdTo,
                                doneOrders[index].done,
                                { isIncrement: true },
                              ) <= -1 ?
                                'text-danger' :
                                ''
                            ]"
                            :disabled="true"
                            :value="inStockTotalAfterSubmit(
                              data.sku_id,
                              getStockId(form.pickedWarehouseIdTo, data.sku_id),
                              form.pickedBinIdTo,
                              doneOrders[index].done,
                              { isIncrement: true },
                            )"
                            type="text"
                            style="border-left: 0px; border-top: 0; border-radius: 0 0 0.25em 0;"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <section-title :title="$t('apps.inventory.message.postingattransferredorders') + ' & ' + $t('message.note')"/>
              <div class="form-row">
                <div class="col-12 col-lg-4 mb-mobile-2">
                  <div class="form-row">
                    <div class="col-12">
                      <div class="input-group">
                        <div
                          class="input-group-prepend"
                          style="max-width: 98px;">
                          <span class="input-group-text text-lowercase">{{ $t('apps.inventory.message.postingattransferredorders') }}</span>
                        </div>
                        <BaseInputDatePicker
                          v-model="form.posting_at"
                          mode="dateTime"
                          is24hr
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-8">
                  <div class="col-md-12 no-padding">
                    <textarea
                      :placeholder="$t('message.note')"
                      v-model="form.note"
                      class="form-control"
                      style="height: 31px !important;"/>
                  </div>
                </div>
              </div>
            </section>
            <!-- <section class="no-margin" style="background: rgba(203,203,203,.2);padding: 14px 0px 5px;"
                     v-if="showBackOrderHTML">
  						<section-title :title="$t('message.warning')"></section-title>
              <div class="col-md-12 no-padding">
                <div class="row" style="margin-bottom: 12px;">
                  <div class="col-12">
                    <p style="margin-bottom: 8px;">{{ $t('apps.inventory.message.backorderdetail') }}</p>
                    <template v-for="(data, index) in doneOrders">
                    <p class="text-danger" style="margin-bottom: 5px;" v-if="data.done < data.quantity">
                      {{ data.item }} {{  $t('apps.inventory.message.missingcount') }} "{{ data.quantity-data.done }}"
                    </p>
                    </template>
                  </div>
                  <div class="col-12 mt-2">
                    <vs-checkbox color="#A3CA76" style="float: left;margin: 0 10px 0 0;" v-model="form.checkboxBackOrder">
                      {{  $t('message.createbackorderauto') }}
                    </vs-checkbox>
                    <a href="#" target="_blank">{{  $t('button.learnmore') }} <i class="fas fa-external-link-alt"></i></a>
                  </div>
                </div>
              </div>
  					</section> -->
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              data-dismiss="modal"
              @click="cancel()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="form.checkboxRespondBy == false"
              type="button"
              class="btn btn-web"
              @click="done()">{{ $t('button.confirm') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              data-dismiss="modal"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="printModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div
            class="modal-body p-0"
            style="background: #C9CCCE;height: 660px;overflow: auto;">
            <print-gt
              v-if="ready"
              :goodstransfer="goodstransfer"
              class="print-template"/>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-web"
              @click="onclickPrint()">{{ $t('button.print') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="closePrintModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

    <BaseConfirmCloneModal
      :show="modalConfirmClone.show"
      :loading="modalConfirmClone.loading"
      @onClose="handleCloseCloneModal"
      @onCancel="handleCancleCloneModal"
      @onConfirm="handleConfirmCloneModal({
        payload: payloadClone,
        createApiFn: insertGoodstransfer,
        redirectTo: 'GoodsTransferAll',
        refCode: 'goodstransfer.gt_code',
      })"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import PrintGt from '@/components/apps/inventory/goodstransfer/include/PrintGt.vue'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'

export default {
  name: 'GoodsTransferEdit',
  components: {
    PrintGt,
    WrapperDoc,
    DocRef,
    BaseConfirmCloneModal,
  },
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      ready: false,

      doneOrders: [],
      showBackOrderHTML: false,

      form: {
        pickedWarehouseIdFrom: null,
        pickedWarehouseIdTo: null,
        pickedBinIdFrom: null,
        pickedBinIdTo: null,
        note: '',
        selectedDate: new Date(),
        trickValidation: 0,
        orders: [],
        checkboxBackOrder: true,
        checkboxRespondBy: true,
        posting_at: new Date(),
      },

      originalForm: null,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      validate: {
        pickedWarehouseIdFrom: '',
        pickedWarehouseIdTo: '',
      },

      isSubmitted: false,

      stocks: [],
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      getMainWarehouse: 'getMainWarehouse',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      getMainStock: 'getMainStock',
      getWarehouseInfo: 'getWarehouseInfo',
      goodstransfer: 'getGoodstransfer',
      dateformat: 'getDateFormat',
      me: 'getMe',
      getBinName: 'getBinName',
      isUseLot: 'isUseLot',
      isUseSerial: 'isUseSerial',
      getInventorySetting: 'getInventorySetting',
      getWhLocationName: 'getWhLocationName',
    }),
    disabledForm () {
      return [
        'done',
      ].includes(this.goodstransfer.status) || !this.hasRoleEdit
    },
    payloadClone() {
      const dataSet = {
      	orders: (() => {
          const orders = []
          for (const order of this.goodstransfer.orders) {
            const stocks = this.stocks.filter((item) => item.sku.sku_id === order.sku_id)
            const stockOut = stocks.find(stock => stock.warehouse.warehouse_id == this.form.pickedWarehouseIdFrom)
            const stockIn = stocks.find(stock => stock.warehouse.warehouse_id == this.form.pickedWarehouseIdTo)

            const newOrder = {
              'sku_id': order.sku_id,
              'item': order.item,
              'quantity': order.quantity,
              'stockout': {
                'stock_id': stockOut.stock.stock_id,
                'warehouse_id': stockOut.warehouse.warehouse_id,
              },
              'stockin': {
                'stock_id': stockIn.stock.stock_id,
                'warehouse_id': stockIn.warehouse.warehouse_id,
              },
            }

            if (order.lot_number) {
              newOrder.lot_number = {
                'bin_location_id': order.lot_number.bin_location_id,
                'date_expire': order.lot_number.date_expire,
                'cost': order.lot_number.cost,
              }
            }

            if (order.serial_numbers) {
              newOrder.serial_numbers = order.serial_numbers.map((ser) => {
                return {
                  'bin_location_id': ser.bin_location_id,
                  'serial_number': ser.serial_number,
                  'date_expire': ser.date_expire,
                  'cost': ser.cost,
                }
              })
            }

            orders.push(newOrder)
          }
          return orders
        })(),
      	stockin: {
      		warehouse_id: this.goodstransfer.stockin.warehouse_id,
      		short_name: this.getWarehouseInfo(this.goodstransfer.stockin.warehouse_id).short_name,
      	},
        stockout: {
      		warehouse_id: this.goodstransfer.stockout.warehouse_id,
      		short_name: this.getWarehouseInfo(this.goodstransfer.stockout.warehouse_id).short_name,
      	},
      	note: this.goodstransfer.note,
        scheduled_at: this.goodstransfer.scheduled_at,
      }
      return dataSet
    },
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    optionWarehouses () {
      const items = this.warehouses.map((item) => {
        return {
          text: item.warehouse_name,
          value: item.warehouse_id,
        }
      })
      return items
    },
    optionFromBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseIdFrom) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
    optionToBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseIdTo) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
  },
  watch: {
    ready: function (isReady) {
      if (isReady) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.update(this.sidebar, 5, [{
        'name': this.$route.query.gt_code,
        'router': {
          'name': 'GoodstransferEdit',
          'query': {
            'gt_id': this.$route.query.gt_id,
            'gt_code': this.$route.query.gt_code,
          },
        },
        'activeClass': 'active',
      }], {
        sidebarAtIdx: 5,
        submenuAtIdx: 2,
      })
    },
    doneOrders: {
      handler: function (newValue) {
        for (let i in this.doneOrders) {
          this.doneOrders[i].done = parseFloat(this.doneOrders[i].done)
        }
      },
      deep: true,
    },
    'form': {
      handler: function () {
        if (this.form.pickedWarehouseIdFrom !== null) {
          this.validate.pickedWarehouseIdFrom = ''
        }
        if (this.form.pickedWarehouseIdTo !== null) {
          this.validate.pickedWarehouseIdTo = ''
        }
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    // set date format
    this.formats.input = [this.dateformat + ' HH:mm:ss']
    this.formats.dayPopover = this.dateformat + ' HH:mm:ss'
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
    /**
     *  validation
     */
    if (!this.$route.query.gt_id) {
      return this.$router.push({ name: 'GoodsTransferAll' })
    }
    // get category
    let res = await this.$store.dispatch('getGoodstransfer', {
      gt_id: this.$route.query.gt_id,
    })
    if (!res.success || res.data.length == 0) {
      return this.$router.push({ name: 'GoodsTransferAll' })
    }
    await this.setStocks()
    /**
     *  validation success
     */

    for (let i = 0; i < this.goodstransfer.orders.length; i++) {
      const order = this.goodstransfer.orders[i]
      await this.$store.dispatch('getProductWithMerge', {
        sku_id: order.sku_id,
      })
    }

    // set default
    this.setData()
    // ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 6,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.update(this.sidebar, 5, [{
      'name': this.$route.query.gt_code,
      'router': {
        'name': 'GoodsTransferEdit',
        'query': {
          'gt_id': this.$route.query.gt_id,
          'gt_code': this.$route.query.gt_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 5,
      submenuAtIdx: 2,
    })
    // scroll to top
    $('body,html').animate({
      scrollTop: 0,
    }, 100)
  },
  mounted: function () { // run script
    // set popup modal
    this.setModal('#doneModal')
    this.setModal('#confirmdeleteModal')
    this.setModal('#printModal')
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },
  methods: {
    ...mapActions([
      'insertGoodstransfer',
    ]),
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    onSubmitOrder (isValid, data) {
      this.isSubmitted = true
      this.validate.pickedWarehouseIdFrom = this.form.pickedWarehouseIdFrom == null ? 'is-invalid' : ''
      this.validate.pickedWarehouseIdTo = this.form.pickedWarehouseIdTo == null ? 'is-invalid' : ''

      let isInValid = !isValid || (this.form.pickedWarehouseIdFrom == null) || (this.form.pickedWarehouseIdTo == null)

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.update(data)
    },
    async update (data) {
      var orders = []

      for (let i in data) {
        let order = data[i]

        var getSku = this.getSkuInfoBySkuId(order.sku_id)
        var stocks

        if (!getSku) {
          let resGetProduct = await this.$store.dispatch('getProduct', {
            sku_id: order.sku_id,
          })
          let product = resGetProduct.data[0]
          let sku = product.prices.find(sku => sku.sku_id == order.sku_id)
          stocks = sku.stocks
        } else {
          stocks = getSku.stocks
        }

        let stockOut = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseIdFrom)
        let stockIn = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseIdTo)

        const newOrder = {
          'sku_id': order.sku_id,
          'item': order.item,
          'quantity': order.quantity,
          'stockout': {
            'stock_id': stockOut.stock_id,
            'warehouse_id': stockOut.warehouse_id,
          },
          'stockin': {
            'stock_id': stockIn.stock_id,
            'warehouse_id': stockIn.warehouse_id,
          },
        }

        if (order.use_lot) {
          newOrder.stockout.lot_numbers = order.lot.selected.map((lot) => {
            return {
              'lot_id': lot.lotId,
              'lot_code': lot.lotCode,
              'bin_location_id': lot.binId,
              'unit': lot.unit,
            }
          })
          newOrder.stockin.bin_location_id = order.lot.binId
        }

        if (order.use_serial) {
          newOrder.stockout.serial_numbers = order.serial.selected.map((ser) => {
            return {
              'ser_id': ser.serId,
              'ser_code': ser.serCode,
              'bin_location_id': ser.binId,
              'serial_number': ser.serialNumber,
            }
          })
          newOrder.stockin.bin_location_id = order.serial.binId
        }

        orders.push(newOrder)
      }

      let dataSet = {
        gt_id: this.goodstransfer.gt_id,
      	orders: orders,
      	note: this.form.note.trim().length > 0 ? this.form.note.trim() : null,
        scheduled_at: this.form.selectedDate ? this.form.selectedDate.toISOString() : this.moment().toISOString(),
        stockout: {
      		warehouse_id: this.form.pickedWarehouseIdFrom,
          bin_location_id: this.form.pickedBinIdFrom,
      		short_name: this.getWarehouseInfo(this.form.pickedWarehouseIdFrom).short_name,
      	},
        stockin: {
      		warehouse_id: this.form.pickedWarehouseIdTo,
          bin_location_id: this.form.pickedBinIdTo,
      		short_name: this.getWarehouseInfo(this.form.pickedWarehouseIdTo).short_name,
      	},
      }

      // save data
      var res = await this.$store.dispatch('updateGoodstransfer', dataSet)

      if (res.success) {
        // get
        await this.$store.dispatch('getGoodstransfer', {
          gt_id: this.goodstransfer.gt_id,
        })
        await this.setStocks()
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.goodstransfer.gt_code }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    async done () {
      this.isSubmitted = true

      let data = {
        'gt_id': this.goodstransfer.gt_id,
        'gt_code': this.goodstransfer.gt_code,
        'note': this.form.note,
        'orders': [],
        'respond_by': this.me.user_id,
        'posting_at': this.form.posting_at.toISOString(),
        stockout: {
      		warehouse_id: this.form.pickedWarehouseIdFrom,
          bin_location_id: this.form.pickedBinIdFrom,
      	},
        stockin: {
      		warehouse_id: this.form.pickedWarehouseIdTo,
          bin_location_id: this.form.pickedBinIdTo,
      	},
      }

      for (let i in this.doneOrders) {
        let item = this.doneOrders[i]

        var getSku = this.getSkuInfoBySkuId(item.sku_id)
        var stocks

        if (!getSku) {
          let resGetProduct = await this.$store.dispatch('getProduct', {
            sku_id: item.sku_id,
          })
          let product = resGetProduct.data[0]
          let sku = product.prices.find(sku => sku.sku_id == item.sku_id)
          stocks = sku.stocks
        } else {
          stocks = getSku.stocks
        }

        let stockOut = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseIdFrom)
        let stockIn = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseIdTo)

        data.orders.push({
          gto_id: item.gto_id,
          sku_id: item.sku_id,
          done: item.done,
          quantity: item.quantity,
          stockout: {
            stock_id: stockOut.stock_id,
            warehouse_id: this.form.pickedWarehouseIdFrom,
            lot_numbers: item.stockout.lot_numbers.map((lot) => {
              return {
                'lot_id': lot.lot_id,
                'lot_code': lot.lot_code,
                'bin_location_id': lot.bin_location_id,
                'unit': lot.unit,
              }
            }),
            serial_numbers: item.stockout.serial_numbers.map((ser) => {
              return {
                'ser_id': ser.ser_id,
                'ser_code': ser.ser_code,
                'bin_location_id': ser.bin_location_id,
                'serial_number': ser.serial_number,
              }
            }),
          },
          stockin: {
            stock_id: stockIn.stock_id,
            warehouse_id: this.form.pickedWarehouseIdTo,
            bin_location_id: item.stockin.bin_location_id,
          },
        })
      }

      let res = await this.$store.dispatch('doneGoodstransfer', data)

      if (res.success) {
        // get goodstransfer
        await this.$store.dispatch('getGoodstransfer', {
          gt_id: this.$route.query.gt_id,
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // close modal
        this.closeReceivedorderModal()
        // finish loading
        this.showFinish(this.$Progress)
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencompleted', { msg: this.goodstransfer.gt_code }),
          color: 'success',
          icon: 'check',
        })
      }
    },
    cancel () {

    },
    setDefaultOrders () {
      let goodstransfer = this.goodstransfer
      let form = this.form

      form.orders = []

      for (let i in goodstransfer.orders) {
        let order = goodstransfer.orders[i]
        form.orders.push({
          sku_id: order.sku_id,
          item: order.item,
          description: '',
          quantity: order.quantity,
          price: 0,
          done: order.done,
          selectize: {
            loading: false,
            updateOption: null,
            trickValidation: 0,
          },
          lot: {
            selected: !order.stockout.lot_numbers ? [] : order.stockout.lot_numbers.map((lot) => {
              return {
                'skuId': order.sku_id,
                'lotId': lot.lot_id,
                'lotCode': lot.lot_code,
                'binId': lot.bin_location_id,
                'binName': this.getBinName(lot.bin_location_id),
                'unit': lot.unit,
              }
            }),
            binId: order.stockin.bin_location_id,
          },
          serial: {
            selected: !order.stockout.serial_numbers ? [] : order.stockout.serial_numbers.map((ser) => {
              return {
                'skuId': order.sku_id,
                'serId': ser.ser_id,
                'serCode': ser.ser_code,
                'serialNumber': ser.serial_number,
                'binId': ser.bin_location_id,
                'binName': this.getBinName(ser.bin_location_id),
                'unit': 1,
              }
            }),
            binId: order.stockin.bin_location_id,
          },
          queryProductName: order.item,
          image: '',
          is_saving_product: false,
        })
      }
    },
    async setData () {
      let goodstransfer = this.goodstransfer
      let form = this.form

      // set general form
      form.selectedDate = this.moment(goodstransfer.scheduled_at).toDate()
      form.pickedWarehouseIdFrom = goodstransfer.stockout.warehouse_id
      form.pickedWarehouseIdTo = goodstransfer.stockin.warehouse_id
      form.pickedBinIdFrom = goodstransfer.stockout.bin_location_id
      form.pickedBinIdTo = goodstransfer.stockin.bin_location_id
      form.note = goodstransfer.note ? goodstransfer.note : ''

      // set oders
      this.setDefaultOrders()

      // set originalForm
      this.originalForm = _.cloneDeep(this.form)
    },
    async del () {
      let data = {
        gt_id: this.goodstransfer.gt_id,
      }

      let res = await this.$store.dispatch('deleteGoodstransfer', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.goodstransfer.gt_code }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to GoodsTransferAll page
        return this.$router.push({ name: 'GoodsTransferAll' })
      }
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    openReceivedorderModal () {
      this.note = this.goodstransfer.note
      this.showBackOrderHTML = false
      this.doneOrders = []
      for (let i in this.goodstransfer.orders) {
        let data = this.goodstransfer.orders[i]
        this.doneOrders.push({
          gto_id: data.gto_id,
          sku_id: data.sku_id,
          stock_id: data.stock_id,
          warehouse_id: data.warehouse_id,
          item: data.item,
          quantity: data.quantity,
          done: data.quantity,
          stockin: data.stockin,
          stockout: data.stockout,
        })
      }

      $('#doneModal').modal('show')

      setTimeout(() => {
        $('.textfield-done').removeClass('text-success text-danger')
        $('.textfield-done').addClass('text-success')
      }, 100)
    },
    closeReceivedorderModal () {
      $('#doneModal').modal('hide')
    },
    checkReceivedNumber (order) {
      let t = this
      let found = false
      for (let i in this.doneOrders) {
        let data = this.doneOrders[i]
        if (data.done < data.quantity) {
          found = true
        }
      }

      this.showBackOrderHTML = found

      $('.textfield-done').each(function (i) {
        let done = parseFloat($(this).val())
        let qty = parseFloat(t.doneOrders[i].quantity)
        $(this).removeClass('text-danger text-success')
        if (done < qty) {
          $(this).addClass('text-danger')
        } else {
          $(this).addClass('text-success')
        }
      })
    },
    onclickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    openPrintModal () {
      $('#printModal').modal('show')

      // set modal height
      $('#printModal .modal-body').css({
        height: window.innerHeight - 125 + 'px',
      })

      $('#printModal .modal-body').animate({ scrollTop: 0 }, 0)
    },
    closePrintModal () {
      $('#printModal').modal('hide')
    },
    getStockId (whId, skuId) {
      const item = this.stocks.find(item => item.warehouse.warehouse_id == whId && item.sku.sku_id === skuId)
      return item ? item.stock.stock_id : null
    },
    inStockTotal (skuId, stockId, binId) {
      try {
        const stock = this.stocks.find((item) => item.stock.stock_id === stockId)
        return stock.stock_locations
          .find((stockLocation) => stockLocation.bin_location_id == binId).instock
      } catch (e) {
        return 0
      }
    },
    inStockTotalAfterSubmit (sku_id, stock_id, binId, newValue, { isIncrement = true }) {
      const total = this.inStockTotal(sku_id, stock_id, binId)
      return isIncrement
        ? total + newValue
        : total - newValue
    },
    handleChangeWhIdFrom() {
      this.form.pickedBinIdFrom = null
    },
    handleChangeWhIdTo() {
      this.form.pickedBinIdTo = null
    },
    async setStocks() {
      const response = await this.$store.dispatch('getStocksBySkus', {
        sku_ids: this.goodstransfer.orders.map((order) => order.sku_id).join(','),
      })
      this.stocks = response.data
    },
  },
}
</script>

<style scoped>
.box {
  padding: 15px;
  background: #F5F5F5;
}
.box:last-of-type {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodstransfer/Edit.vue